export default __webpack_public_path__ + "static/media/qrcode-site-1440w.edebb3c6.webp";